import {
  Wrench, Home, Building2, HardHat, Droplets, Zap, PaintRoller,
  LayoutGrid, Hammer, KeyRound, DoorOpen, LineChart,
} from "lucide-react";

export const CONTACT = {
  brand: "Мастер на все руки",
  phones: [
    { display: "+90 553 484 4066", tel: "+905534844066" },
    { display: "+90 552 655 66 07", tel: "+905526556607" },
  ],
  whatsapp: "905534844066",
};

export const SERVICE_ICONS = {
  repairs: Wrench,
  home: Home,
  commercial: Building2,
  construction: HardHat,
  plumbing: Droplets,
  electrical: Zap,
  painting: PaintRoller,
  flooring: LayoutGrid,
  install: Hammer,
  sales: KeyRound,
  rentals: DoorOpen,
  consulting: LineChart,
};

export const IMAGES = {
  heroPrimary:
    "https://images.pexels.com/photos/31737860/pexels-photo-31737860.jpeg",
  heroWorkers:
    "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwYnVpbGRlcnN8ZW58MHx8fHwxNzgyNTk1ODU0fDA&ixlib=rb-4.1.0&q=85",
  aboutInterior:
    "https://images.unsplash.com/photo-1649083048770-82e8ffd80431?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxpbnRlcmlvciUyMGRlc2lnbiUyMHJlbm92YXRpb24lMjBtb2Rlcm58ZW58MHx8fHwxNzg1NTA1MzIwfDA&ixlib=rb-4.1.0&q=85",
  kitchen:
    "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxpbnRlcmlvciUyMGRlc2lnbiUyMHJlbm92YXRpb24lMjBtb2Rlcm58ZW58MHx8fHwxNzg1NTA1MzIwfDA&ixlib=rb-4.1.0&q=85",
  grinder:
    "https://images.unsplash.com/photo-1694522362256-6c907336af43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwYnVpbGRlcnN8ZW58MHx8fHwxNzgyNTk1ODU0fDA&ixlib=rb-4.1.0&q=85",
  crane:
    "https://images.unsplash.com/photo-1599707254554-027aeb4deacd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwYnVpbGRlcnN8ZW58MHx8fHwxNzgyNTk1ODU0fDA&ixlib=rb-4.1.0&q=85",
  electrician:
    "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxwbHVtYmluZyUyMGVsZWN0cmljYWwlMjByZXBhaXIlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzg1NTA1MzI2fDA&ixlib=rb-4.1.0&q=85",
  plumbing:
    "https://images.unsplash.com/photo-1676210133055-eab6ef033ce3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxwbHVtYmluZyUyMGVsZWN0cmljYWwlMjByZXBhaXIlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzg1NTA1MzI2fDA&ixlib=rb-4.1.0&q=85",
  painting:
    "https://images.unsplash.com/photo-1652829069834-2c05031199c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxwYWludGluZyUyMHRpbGluZyUyMGZsb29yaW5nJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc4NTUwNTMyNnww&ixlib=rb-4.1.0&q=85",
  flooring:
    "https://images.unsplash.com/flagged/photo-1556438758-872c68902f60?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxwYWludGluZyUyMHRpbGluZyUyMGZsb29yaW5nJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc4NTUwNTMyNnww&ixlib=rb-4.1.0&q=85",
  realEstate:
    "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxyZWFsJTIwZXN0YXRlJTIwaG91c2UlMjBrZXlzJTIwYWdlbnR8ZW58MHx8fHwxNzgzODcyNjg2fDA&ixlib=rb-4.1.0&q=85",
};

// Before / After portfolio pairs (reusing curated stock imagery deliberately).
export const PORTFOLIO = [
  { id: "kitchen", before: IMAGES.grinder, after: IMAGES.kitchen, ru: "Кухня под ключ", en: "Turnkey kitchen", tr: "Anahtar teslim mutfak" },
  { id: "living", before: IMAGES.painting, after: IMAGES.aboutInterior, ru: "Гостиная", en: "Living room", tr: "Oturma odası" },
  { id: "bath", before: "/bath-before.png", after: "/bath-after.png", ru: "Санузел", en: "Bathroom", tr: "Banyo" },
  { id: "facade", before: IMAGES.crane, after: IMAGES.heroPrimary, ru: "Фасад дома", en: "House facade", tr: "Ev cephesi" },
];
